/**
 * =========================================================================================
 * Component - UPagination
 * =========================================================================================
 **/

import React, {useEffect, useMemo, useState} from 'react';
import {COLOR, PAGINATION, LIST} from "../constant";
import {findArray} from "../common/function";
import ReactPaginate from 'react-paginate';
import Select from 'react-select';
import * as Icon from 'ubs-icons';

const UPagination = React.memo((props) => {

    const recordsPerPage = useMemo(() => findArray(LIST.RECORD_PER_PAGE, props?.limit), [props?.limit])
    const pageCount = useMemo(() => {
        const count = Math.ceil(props.totalRecords / props?.limit)
        return count >= 0 ? count : 1
    }, [props.totalRecords, props?.limit])

    const paginationClick = (data) => {
        props.onChange(data);
    }

    const handlePageClick = ({selected: selectedPage}) => {
        /**
         * Add 1 count in selected because pagination index is starting from 0
         * Reason: We have to send to backend 1 and pagination component
         * return 0 that's why we are adding 1
         **/
        paginationClick({limit: props?.limit, currentPage: selectedPage + 1});
        const dom = document.querySelector(`.u_table-resource`)
        dom?.scrollIntoView({behavior: "smooth", block: "nearest"});
    }

    const handleLimit = (data) => {
        paginationClick({limit: data?.value, currentPage: PAGINATION?.CURRENT_PAGE})
    }

    return (
        <React.Fragment>
            <div className="u_pagination" id="u_pagination">
                <div className="u_pagination-record u_flex u_align-center">
                    <span className="u_pagination-title u_mr-10">Entries</span>
                    <div className="u_pagination-record-wpr">
                        <Select
                            classNamePrefix="u_record"
                            options={LIST.RECORD_PER_PAGE}
                            menuPlacement="top"
                            isSearchable={false}
                            value={recordsPerPage}
                            onChange={handleLimit}
                        >
                        </Select>
                    </div>
                </div>
                <ReactPaginate
                    previousLabel={<Icon.LeftArrow size={15} fill={COLOR.u_icon_bg}/>}
                    nextLabel={<Icon.RightArrow size={15} fill={COLOR.u_icon_bg}/>}
                    pageCount={pageCount}
                    onPageChange={handlePageClick}
                    containerClassName={'u_flex'}
                    pageLinkClassName={'u_pagination-link'}
                    previousLinkClassName={'u_pagination-link u_pagination-link-previous'}
                    breakLinkClassName={'u_pagination-link u_pagination-link-break'}
                    nextLinkClassName={'u_pagination-link u_pagination-link-next'}
                    disabledLinkClassName={'u_pagination-link-disabled'}
                    activeLinkClassName={'u_pagination-link-active'}
                    forcePage={props?.currentPage ? (props?.currentPage - 1) : 1}
                />
            </div>
        </React.Fragment>
    );
});

export default UPagination;